export const state = () => ({
	isOpen: false,

	params: {
		title: "",
		message: "",

		buttonSuccessLabel: "",
		buttonSuccessEvent: null,

		buttonErrorLabel: "",
		buttonErrorEvent: null,
	}
});

export const mutations = {
	openPopUp: function (state, params) {
		state.isOpen = true;
		state.params = {...params};
	},
	closePopUp: function (state) {
		state.isOpen = false;
		state.params = {};
	},
};
